import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import * as participanteService from "../../services/participanteService";
import { Grid, Card, CardContent, Snackbar, Alert, Button } from '@mui/material';
import { AssignmentInd as IconFicha } from '@mui/icons-material';
import { puedeAccederFichaIngreso } from '../../services/permisoService';
import { obtenerUsuario } from '../../services/authService';
import Member from '../../components/Member'
import MemberAllergy from '../../components/MemberAllergy'
import MemberAuthorizedPerson from '../../components/MemberAuthorizedPerson'
import MemberLanguageLevel from '../../components/MemberLanguageLevel'
import PersonBonding from '../../components/PersonBonding'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsMember } from '../../redux/memberSlice';
import { setEntity as setMemberAllergy, activeValidations as activeMemberAllergy } from '../../redux/memberAllergySlice';
import { setEntity as setMemberLanguageLevel, activeValidations as activeMemberLanguageLevel } from '../../redux/memberLanguageLevelSlice';
import { setEntity as setMemberAuthorizedPerson, activeValidations as activeMemberAuthorizedPerson } from '../../redux/memberAuthorizedPersonSlice';

const Edit = (props) => {
   const participante = useSelector((state) => state.member.participante);
   const participanteAlergia = useSelector((state) => state.memberAllergy.entity);
   const participantePersonaAutorizada = useSelector((state) => state.memberAuthorizedPerson.entity);
   const participanteNivelLenguaje = useSelector((state) => state.memberLanguageLevel.entity);
   const personaVinculacion = useSelector((state) => state.personBonding["memberPersonBonding"]?.personaVinculaciones);

   const participanteValidation = useSelector((state) => state.member.validationMessage);
   const participanteAlergiaValidation = useSelector((state) => state.memberAllergy.validationMessage);

   const defaultParticipanteAlergia = useSelector((state) => state.memberAllergy.defaultEntity)
   const defaultParticipanteAuthorizedPerson = useSelector((state) => state.memberAuthorizedPerson.defaultEntity)
   const defaultParticipanteNivelLenguaje = useSelector((state) => state.memberLanguageLevel.defaultEntity)
  
   const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const [idNew, setIdNew] = useState(0)
  const [idPersona, setIdPersona] = useState(0)

  const dispatch = useDispatch();
  const params = useParams();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("participante");
  const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;

  const postEntity = async () => {
    const filialEfectiva = participante.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0);
    var dataPost = {
      ...participante,
      idFilial: filialEfectiva > 0 ? filialEfectiva : null
      //, idTerapeuta: parseInt(participante.idTerapeuta)
      , participanteAlergia: participanteAlergia, participantePersonaAutorizada: participantePersonaAutorizada
      , participanteNivelLenguaje: participanteNivelLenguaje
      , personaVinculacion: personaVinculacion
    }

    const messages = (participanteValidation || []).filter(msg => {
      if (msg === "Seleccione la filial" && filialEfectiva > 0) return false;
      return true;
    });
    var ValidationMessages = messages.concat(participanteAlergiaValidation || [])

    if (ValidationMessages.length > 0) {
      dispatch(activeMemberAllergy());
      dispatch(activeMemberAuthorizedPerson());
      dispatch(activeValidationsMember());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await participanteService.postParticipanteWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          setIdNew(parseInt(response.data.data))

          if (participante.id > 0){
            participanteService.getsParticipanteAlergia(participante.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setMemberAllergy(defaultParticipanteAlergia));
              else
                dispatch(setMemberAllergy(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            participanteService.getsParticipantePersonaAutorizada(participante.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setMemberAuthorizedPerson(defaultParticipanteAuthorizedPerson));
              else
                dispatch(setMemberAuthorizedPerson(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            participanteService.getsParticipanteNivelLenguaje(participante.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setMemberLanguageLevel(defaultParticipanteNivelLenguaje));
              else
                dispatch(setMemberLanguageLevel(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });
          }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  const rolesUsuario = useSelector((state) => state.seguridad?.roles) || [];
  const usuarioActual = obtenerUsuario();
  const tienePermisoFicha = puedeAccederFichaIngreso(usuarioActual, rolesUsuario);

  const idEfectivo = (params.id && parseInt(params.id, 10) > 0) ? parseInt(params.id, 10) : idNew;

  const extraActions = tienePermisoFicha ? (
    <Button
      variant={idEfectivo > 0 ? "contained" : "outlined"}
      color="secondary"
      size="small"
      startIcon={<IconFicha />}
      component={idEfectivo > 0 ? Link : "button"}
      to={idEfectivo > 0 ? `/reporte/ficha-participante?idParticipante=${idEfectivo}` : undefined}
      disabled={!idEfectivo || idEfectivo <= 0}
      title={idEfectivo > 0 ? "Ver / Imprimir Ficha de Matrícula" : "Se habilita al registrar el participante"}
    >
      Ficha de Matrícula
    </Button>
  ) : null;

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nuevo" : "Editar") + " Participante"}
        backTo={"/member"}
        onSave={postEntity}
        disabled={isReadOnly}
        extraActions={extraActions}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Member onPersonaChange={setIdPersona} isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <PersonBonding sliceKey={"memberPersonBonding"} hideInputs={false} id={idPersona} isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <MemberLanguageLevel isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <MemberAuthorizedPerson isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <MemberAllergy isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
